module.exports = __webpack_public_path__ + "static/media/t_2.e3b4753c.jpg";